import { LINK_QUERY_FIELDS, IMAGE_QUERY_FIELDS, RICHTEXT_QUERY_FIELDS } from '.';

const getGlobalQuery = (locale, name, preview) => `
  {
    globalModuleCollection(
      limit: 1
      locale: "${locale}"
      where: { name: "${name}" }
      preview: ${preview}
    ) {
      items {
        sys {
          id
        }
        name
        table
        resourcesCollection {
          items {
            ... on ComponentRichText {
              __typename
              richText {
                json
              }
            }
            ... on ComponentMicrocopy {
              __typename
              name
              text
            }
            ... on ComponentMedia {
              __typename
              name
              image {
                url
                width
                height
              }
            }
            ... on ComponentLink {
              __typename
              name
              ${LINK_QUERY_FIELDS}
            }
            ... on ComponentNav {
              __typename
              name
              linksCollection(limit: 10) {
                items {
                  ... on ComponentLink {
                    __typename
                    name
                    ${LINK_QUERY_FIELDS}
                  }
                }
              }
            }
            ... on ComponentArticle {
              __typename
              name
              title
              slug
              article {
                json
              }
              submenusCollection(skip: 0, limit: 20) {
                items {
                  ... on ComponentArticle {
                    __typename
                    name
                    title
                    article {
                      json
                    }
                  }
                }
              }
            }
          }
          items {
            ... on ComponentJson {
              __typename
              name
              jsonObject
            }
          }
        }
      }
    }
  }
`;

const getGlobalMicrocopiesQuery = (locale, name) => `
  {
    globalModuleCollection(
      limit: 1
      locale: "${locale}"
      where: { name: "${name}" }
    ) {
      items {
        sys {
          id
        }
        resourcesCollection {
          items {
            ... on ComponentMicrocopy {
              __typename
              name
              text
            }
            ... on ComponentMedia {
              __typename
              name
              imagesCollection {
                items {
                  url
                  title
                }
              }
            }
          }
        }
      }
    }
  }
`;

const getAccountQuery = (locale, name) => `
  {
    globalModuleCollection(
      limit: 1
      locale: "${locale}"
      where: { name: "${name}" }
    ) {
      items {
        sys {
          id
        }
        name
        resourcesCollection {
          items {
            ... on ComponentMicrocopy {
              __typename
              name
              text
            }
            ... on ComponentMedia {
              __typename
              name
              image {
                url
                width
                height
              }
            }
            ... on ComponentRichText {
              __typename
              name
              richText {
                ${RICHTEXT_QUERY_FIELDS}
              }
            }
            ... on ComponentNav {
              __typename
              name
              linksCollection(limit: 10) {
                items {
                  ... on ComponentLink {
                    __typename
                    name
                    ${LINK_QUERY_FIELDS}
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const getLookbookQuery = (locale, name, preview) => `
  {
    globalModuleCollection(
      limit: 1
      locale: "${locale}"
      where: { name: "${name}" }
      preview: ${preview}
    ) {
      items {
        sys {
          id
        }
        name
        resourcesCollection(skip: 0, limit: 15) {
          items {
            ...on SectionLookbookGroup {
              __typename
              name
              title
              description
              withGap
              resourcesCollection {
                items {
                  ...on SectionLookbook {
                    name
                    title
                    description
                    thumbnail {
                      url
                      width
                      height
                    }
                    genderFilter
                    collectionCollection(skip: 0, limit: 4) {
                      items {
                        ... on PageProduct {
                          shopifyIdEu
                          shopifyIdGb
                          shopifyIdUs
                        }
                      }
                    }
                  }
                }
              }
            }
            ... on ComponentArticle {
              __typename
              name
              title
              article {
                json
              }
              image {
                ${IMAGE_QUERY_FIELDS}
              }
              mobileImage {
                ${IMAGE_QUERY_FIELDS}
              }
            }
            ...on ComponentMicrocopy {
              __typename
              name
              text
            }
            ...on ComponentArticle {
              __typename
              name
              title
              article {
                json
              }
              image {
                ${IMAGE_QUERY_FIELDS}
              }
              mobileImage {
                ${IMAGE_QUERY_FIELDS}
              }
            }
            ... on ComponentNav {
              __typename
              name
              linksCollection(limit: 5) {
                items {
                  ... on ComponentLink {
                    __typename
                    name
                    ${LINK_QUERY_FIELDS}
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const getFitGuideQuery = (locale, name, preview = false) => `
  {
    globalModuleCollection(
      limit: 1
      locale: "${locale}"
      preview: ${preview}
      where: { name: "${name}" }
    ) {
      items {
        name
        sys {
          id
        }
        resourcesCollection {
          items {
            ... on ComponentFitType {
              __typename
              sys {
                id
              }
              thumbnailImage {
                name
                image {
                  url
                  title
                  description
                  width
                  height
                }
                vimeoUrl
              }
              name
              availableJeanTypesCollection (limit: 10) {
                items {
                  ... on PageCollection {
                    __typename
                    sys {
                      id
                    }
                  }
                }
              }
            }
            ... on ComponentMicrocopy {
              __typename
              name
              text
            }
            ... on ComponentNav {
              __typename
              name
              linksCollection(limit: 5) {
                items {
                  ... on ComponentLink {
                    __typename
                    name
                    ${LINK_QUERY_FIELDS}
                  }
                }
              }
            }
            ... on ComponentMedia {
              __typename
              name
              imagesCollection(skip: 0, limit: 15) {
                items {
                  url
                  title
                  width
                  height
                }
              }
            }
            ... on ComponentLink {
              __typename
              name
              ${LINK_QUERY_FIELDS}
            } 
          }
        }
      }
    }
  }
`;

export const getGlobalModuleQuery = ({ locale, name, preview }) => {
  if (name.startsWith('Newsletter page -') || name === 'Newsletter')
    return getAccountQuery(locale, name);

  if (name.startsWith('Account -')) return getAccountQuery(locale, name);

  if (name.startsWith('Lookbook - ') || name === 'Lookbook')
    return getLookbookQuery(locale, name, preview);

  if (name.startsWith('Fit-Guide-')) return getFitGuideQuery(locale, name, preview);

  switch (name) {
    case 'Global Microcopies':
      return getGlobalMicrocopiesQuery(locale, name);
    default:
      return getGlobalQuery(locale, name, preview);
  }
};

export default getGlobalModuleQuery;
